import type { UserAvatarByEmailProps } from "./types-user-avatar-by-email";
import { useUserAvatarByEmail } from "./use-user-avatar-by-email";
import { UserAvatarByEmailView } from "./view-user-avatar-by-email";

/**
 * Avatar que resolve a foto pelo e-mail (`/api/plataforma/usuarios/foto?email=`).
 * A busca só começa quando o avatar entra na viewport (tabelas longas não disparam uma
 * requisição por linha). Qualquer falha ou ausência de foto exibe as iniciais, sem erro.
 */
export function UserAvatarByEmail(props: UserAvatarByEmailProps) {
  const vm = useUserAvatarByEmail(props);

  return <UserAvatarByEmailView {...vm} />;
}

export type * from "./types-user-avatar-by-email";
